import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const getAllCategoryList = createAsyncThunk(
    "getAllCategoryList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/remarkticket/category-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const CategorySlice = createSlice({
    name: "CategorySlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllCategoryList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getAllCategoryList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(getAllCategoryList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default CategorySlice.reducer;
